export default "__VITE_ASSET__tT8QAo0x__"